import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { Observable, Subscription } from 'rxjs';

import { ToastrService } from 'ngx-toastr';

import { AppState } from 'src/app/state';
import { Study } from 'src/app/models/study';
import { importTemplate } from 'src/app/dashboard/state/templates/templates.actions';
import { selectSelectedStudy } from 'src/app/dashboard/state/study/study.selectors';
import {
  selectIsImportingTemplate,
  selectTemplateImported,
} from 'src/app/dashboard/state/templates/templates.selectors';

const SELECT_JSON_FILE_LABEL = 'Select JSON file';

@Component({
  selector: 'dashboard-import-template',
  templateUrl: './import-template.component.html',
  styleUrls: ['./import-template.component.scss'],
})
export class ImportTemplateComponent implements OnInit, OnDestroy {
  isImportingTemplate$: Observable<boolean>;
  templateImported$: Observable<boolean>;

  selectedStudy: Study;

  importFilename: string;
  importFiles: File[];

  SELECT_JSON_FILE_LABEL = SELECT_JSON_FILE_LABEL;

  private subscriptions = new Subscription();

  constructor(private toastrService: ToastrService, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.isImportingTemplate$ = this.store.select(selectIsImportingTemplate);
    this.templateImported$ = this.store.select(selectTemplateImported);

    this.subscriptions.add(this.store.select(selectSelectedStudy).subscribe((study) => (this.selectedStudy = study)));
  }

  selectJSON(fileToImport) {
    const regex = new RegExp('(.*?).(json)$');

    if (!fileToImport.target.files || !fileToImport.target.files.length) {
      return;
    }

    this.importFilename = fileToImport.target.files[0].name.toLowerCase();

    if (!regex.test(this.importFilename)) {
      this.toastrService.error('Please select a file with a .json extension');
      this.importFilename = null;
      return;
    }

    this.SELECT_JSON_FILE_LABEL = this.importFilename.slice(0, 20);
    this.importFiles = fileToImport.target.files;
  }

  doImport() {
    this.store.dispatch(importTemplate({ studyId: this.selectedStudy?.id, importFile: this.importFiles[0] }));

    this.importFilename = null;
    this.importFiles = [];
    this.SELECT_JSON_FILE_LABEL = SELECT_JSON_FILE_LABEL;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
